import { JTextArea as CJTextArea } from './../../../JForm/JTextArea/JTextArea';
import React, { FC } from 'react';

import { JFieldBaseProps } from './../../models';
import { FormItem } from './../FormItem';

export const JTextArea: FC<JFieldBaseProps> = (props) => {
    return (
        <FormItem fieldProps={props}>
            <CJTextArea
                name={props.name}
                maxLength={0}
                disabled={props.disabled}
                placeholder={props.placeholder}
                textAreaProps={{ autoSize: { minRows: 4, maxRows: 10 }, }}
                errorMessage={props.validationMessage}
            />
        </FormItem>
    )
}